import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Box,
    Card,
    Button,
    makeStyles,
    Container,
    Divider,
    CardContent,
    CardHeader,
    Grid,
    TextField,
    MenuItem,
    InputLabel,
    TableHead,
    TableRow,
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import * as Yup from "yup";
import { LoadingComponent } from 'src/utils/newLoader';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik, validateYupSchema } from 'formik';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { useAlert } from "react-alert";
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import xlsx from 'json-as-xlsx';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    colorCancel: {
        backgroundColor: "red",
    },
    colorRecordAndNew: {
        backgroundColor: "#FFBE00"
    },
    colorRecord: {
        backgroundColor: "green",
    }
}));

const screenCode = 'LOANWISECROPREPORT';

export default function LoanWiseCropReport(props) {
    const [title, setTitle] = useState("Loan Wise Crop Report")
    const classes = useStyles();
    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [routes, setRoutes] = useState();
    const [limit, setLimit] = useState(5);
    const [page, setPage] = useState(0);
    const [loanInputData, setLoanInputData] = useState({
        groupID: '0',
        factoryID: '0',
        routeID: '0'
    })
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const navigate = useNavigate();
    const alert = useAlert();
    const [loanWiseDetails, setLoanWiseDetails] = useState([]);
    const [csvHeaders, SetCsvHeaders] = useState([])
    const componentRef = useRef();
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupName: "0",
        factoryName: "0",
        routeName: "0"
    })

    useEffect(() => {
        trackPromise(getGroupsForDropdown(),
            getPermission());
    }, []);

    useEffect(() => {
        trackPromise(getFactoriesForDropDown());
    }, [loanInputData.groupID]);

    useEffect(() => {
        trackPromise(
            getRoutesByFactoryID()
        )
    }, [loanInputData.factoryID]);

    async function getPermission() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWLOANWISECROPREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
        });

        setLoanInputData({
            ...loanInputData,
            groupID: parseInt(tokenService.getGroupIDFromToken()),
            factoryID: parseInt(tokenService.getFactoryIDFromToken())
        })
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }

    async function getFactoriesForDropDown() {
        const factory = await services.getFactoryByGroupID(loanInputData.groupID);
        setFactories(factory);
    }

    async function getRoutesByFactoryID() {
        const route = await services.getRoutesForDropDown(loanInputData.factoryID);
        setRoutes(route);
    }

    async function GetDetails() {
        let model = {
            groupID: parseInt(loanInputData.groupID),
            factoryID: parseInt(loanInputData.factoryID),
            routeID: parseInt(loanInputData.routeID)
        }
        getSelectedDropdownValuesForReport(model);
        const loanData = await services.GetLoanWiseCropDetails(model);
        if (loanData.statusCode == "Success" && loanData.data != null) {
            setLoanWiseDetails(loanData.data);
            createDataForExcel(loanData.data);
            if (loanData.data.length == 0) {
                alert.error("No records to display");
            }
        }
        else {
            alert.error("No records to display");
        }
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'Route Name':{
                        t: 's',
                        v: String(x.routeName),
                        s: {alignment: { horizontal: 'left' }}
                    },
                    'Registration Number':{
                        t: 's',
                        v: String(x.registrationNumber),
                        s: {alignment: { horizontal: 'left' }}
                    },
                    'Customer Name':{
                        t: 's',
                        v: String(x.name),
                        s: {alignment: { horizontal: 'left' }}
                    },
                    'Loan Issued Date':{
                        t: 's',
                        v: x.loanIssuedDate.split('T')[0],
                        s: {alignment: { horizontal: 'left' }}
                    },
                    'Principal Amount (Rs.)':{
                        t: 'n',
                        v: parseFloat(x.principalAmount),
                        z: '0.00',
                        s: {alignment: { horizontal: 'right' }}
                    },
                    'No of Installments': x.numberOfInstalments,
                    'Interest Rate (%)':{
                        t: 'n',
                        v: parseFloat(x.annualRate),
                        z: '0.00',
                        s: {alignment: { horizontal: 'right' }}
                    },
                    'Before 3 Months Crop Average':{
                        t: 'n',
                        v: parseFloat(x.beforeThreeMonthCrop),
                        z: '0.00',
                        s: {alignment: { horizontal: 'right' }}
                    },
                    'After 3 Months Crop Average':{
                        t: 'n',
                        v: parseFloat(x.afterThreeMonthCrop),
                        z: '0.00',
                        s: {alignment: { horizontal: 'right' }}
                    },
                    'Last Month Crop (KG)':{
                        t: 'n',
                        v: parseFloat(x.lastMonthCrop),
                        z: '0.00',
                        s: {alignment: { horizontal: 'right' }}
                    },
                    'Last Month Debt (Rs.)':{
                        t: 'n',
                        v: parseFloat(x.lastMonthDebt),
                        z: '0.00',
                        s: {alignment: { horizontal: 'right' }}
                    },
                }
                res.push(vr);
            });

            res.push({});

            var vr = {
                'Route Name': "Group :" + selectedSearchValues.groupName,
                'Registration Number': "Factory :" + selectedSearchValues.factoryName,
                'Customer Name': selectedSearchValues.routeName == undefined ? 'Route Name :' + 'All Routes' : 'Route Name :' + selectedSearchValues.routeName,
            }
            res.push(vr);
        }

        return res;
    }

    async function createFile() {
        var file = await createDataForExcel(loanWiseDetails);
        var settings = {
            sheetName: 'Loan Wise Crop Report',
            fileName: 'Loan Wise Crop Report' + ' ' + selectedSearchValues.groupName + ' ' + selectedSearchValues.factoryName,
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'Loan Wise Crop Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            groupName: groups[searchForm.groupID],
            factoryName: factories[searchForm.factoryID],
            routeName: routes[searchForm.routeID]
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
            </Grid>
        )
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value
        setLoanInputData({
            ...loanInputData,
            [e.target.name]: value
        });
        setLoanWiseDetails([]);
    }

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const getPageMargins = () => {
        return `@media print {
          @page {
            size: A4 Portrait !important;
            margin: 50px 24px 56px 24px !important;
            background-color: white !important;
          }
          body {
            transform: scale(1);
            transform-origin: top left;
            background-color: white !important;
            width: 100%;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
        }`;
    };

    return (
        <Fragment>
            <LoadingComponent />
            <Page className={classes.root} title={title}>
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            groupID: loanInputData.groupID,
                            factoryID: loanInputData.factoryID
                        }}
                        validationSchema={
                            Yup.object().shape({
                                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required')
                            })
                        }
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader
                                            title={cardTitle(title)}
                                        />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent>
                                                <Grid container spacing={3}>
                                                    <Grid item md={4} xs={8}>
                                                        <InputLabel shrink id="groupID">
                                                            Group *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            fullWidth
                                                            helperText={touched.groupID && errors.groupID}
                                                            name="groupID"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={loanInputData.groupID}
                                                            variant="outlined"
                                                            id="groupID"
                                                            disabled={!permissionList.isGroupFilterEnabled}
                                                            size="small"
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(groups)}
                                                        </TextField>
                                                    </Grid>

                                                    <Grid item md={4} xs={8}>
                                                        <InputLabel shrink id="factoryID">
                                                            Factory *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.factoryID && errors.factoryID)}
                                                            fullWidth
                                                            helperText={touched.factoryID && errors.factoryID}
                                                            name="factoryID"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={loanInputData.factoryID}
                                                            variant="outlined"
                                                            id="factoryID"
                                                            disabled={!permissionList.isFactoryFilterEnabled}
                                                            size="small"
                                                        >
                                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                                            {generateDropDownMenu(factories)}
                                                        </TextField>
                                                    </Grid>

                                                    <Grid item md={4} xs={8}>
                                                        <InputLabel shrink id="routeID">
                                                            Route
                                                        </InputLabel>
                                                        <TextField select
                                                            fullWidth
                                                            name="routeID"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={loanInputData.routeID}
                                                            variant="outlined"
                                                            id="routeID"
                                                            size="small"
                                                        >
                                                            <MenuItem value="0">--Select Routes--</MenuItem>
                                                            {generateDropDownMenu(routes)}
                                                        </TextField>
                                                    </Grid>
                                                </Grid>

                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <Button
                                                        color="primary"
                                                        type="submit"
                                                        variant="contained"
                                                        onClick={() => trackPromise(GetDetails())}
                                                    >
                                                        Search
                                                    </Button>
                                                </Box>
                                                <br /> <br />
                                                    {loanWiseDetails.length > 0 ?
                                                        <Box>
                                                            <TableContainer>
                                                                <Table aria-label="caption table">
                                                                    <TableHead>
                                                                        <TableRow style={{ border: "2px solid #ccc" }}>
                                                                             <TableCell align={'center'} style={{ width: '200px', border: "2px solid #ccc", fontWeight: "bold", fontSize: "14px", paddingBottom: "1px", paddingTop: "1px" }}>Route Name</TableCell>
                                                                             <TableCell align={'center'} style={{ width: '120px', border: "2px solid #ccc", fontWeight: "bold", fontSize: "14px", paddingBottom: "1px", paddingTop: "1px" }}>Registration Number</TableCell>
                                                                             <TableCell align={'center'} style={{ width: '200px', border: "2px solid #ccc", fontWeight: "bold", fontSize: "14px", paddingBottom: "1px", paddingTop: "1px" }}>Customer Name</TableCell>
                                                                             <TableCell align={'center'} style={{ width: '250px', border: "2px solid #ccc", fontWeight: "bold", fontSize: "14px", paddingBottom: "1px", paddingTop: "1px" }}>Loan Issued Date</TableCell>
                                                                             <TableCell align={'center'} style={{ width: '120px', border: "2px solid #ccc", fontWeight: "bold", fontSize: "14px", paddingBottom: "1px", paddingTop: "1px" }}>Principal Amount (Rs.)</TableCell>                                                                    
                                                                             <TableCell align={'center'} style={{ width: '120px', border: "2px solid #ccc", fontWeight: "bold", fontSize: "14px", paddingBottom: "1px", paddingTop: "1px" }}>No of Installments</TableCell>
                                                                             <TableCell align={'center'} style={{ width: '120px', border: "2px solid #ccc", fontWeight: "bold", fontSize: "14px", paddingBottom: "1px", paddingTop: "1px" }}>Interest Rate (%)</TableCell>
                                                                             <TableCell align={'center'} style={{ width: '120px', border: "2px solid #ccc", fontWeight: "bold", fontSize: "14px", paddingBottom: "1px", paddingTop: "1px" }}>Before 3 Months Crop Average</TableCell>    
                                                                             <TableCell align={'center'} style={{ width: '120px', border: "2px solid #ccc", fontWeight: "bold", fontSize: "14px", paddingBottom: "1px", paddingTop: "1px" }}>After 3 Months Crop Average</TableCell> 
                                                                             <TableCell align={'center'} style={{ width: '120px', border: "2px solid #ccc", fontWeight: "bold", fontSize: "14px", paddingBottom: "1px", paddingTop: "1px" }}>Last Month Crop (KG)</TableCell>
                                                                             <TableCell align={'center'} style={{ width: '120px', border: "2px solid #ccc", fontWeight: "bold", fontSize: "14px", paddingBottom: "1px", paddingTop: "1px" }}>Last Month Debt (Rs.)</TableCell>
                                                                        </TableRow>
                                                                    </TableHead>                                                                   
                                                                    <TableBody>
                                                                        {loanWiseDetails.slice(page * limit, page * limit + limit).map((data, index) => (
                                                                            <TableRow key={index} style={{ border: "2px solid #ccc" }}> 
                                                                                <TableCell align={'left'} component="th" scope="row" style={{ fontSize: "14px", border: "2px solid #ccc" }}>
                                                                                    {data.routeName}
                                                                                </TableCell>
                                                                                <TableCell align={'left'} component="th" scope="row" style={{ fontSize: "14px", border: "2px solid #ccc" }}>
                                                                                    {data.registrationNumber}
                                                                                </TableCell>
                                                                                <TableCell align={'left'} component="th" scope="row" style={{ width: "300" , fontSize: "14px", border: "2px solid #ccc" }}>
                                                                                    {data.name}
                                                                                </TableCell>
                                                                                <TableCell align={'center'} component="th" scope="row" style={{  fontSize: "14px", border: "2px solid #ccc" }}>
                                                                                    {data.loanIssuedDate.split('T')[0]}
                                                                                </TableCell>
                                                                                <TableCell align={'right'} component="th" scope="row" style={{ fontSize: "14px", border: "2px solid #ccc" }}>
                                                                                    {Number(data.principalAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                </TableCell>
                                                                                <TableCell align={'right'} component="th" scope="row" style={{ fontSize: "14px", border: "2px solid #ccc" }}>
                                                                                    {data.numberOfInstalments}
                                                                                </TableCell>
                                                                                <TableCell align={'right'} component="th" scope="row" style={{  fontSize: "14px", border: "2px solid #ccc" }}>
                                                                                    {Number(data.annualRate).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                </TableCell>
                                                                                <TableCell align={'right'} component="th" scope="row" style={{ fontSize: "14px", border: "2px solid #ccc" }}>
                                                                                    {Number(data.beforeThreeMonthCrop).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                </TableCell>
                                                                                <TableCell align={'right'} component="th" scope="row" style={{  fontSize: "14px", border: "2px solid #ccc" }}>
                                                                                    {Number(data.afterThreeMonthCrop).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                </TableCell>
                                                                                <TableCell align={'right'} component="th" scope="row" style={{  fontSize: "14px", border: "2px solid #ccc" }}>
                                                                                    {Number(data.lastMonthCrop).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                </TableCell>
                                                                                <TableCell align={'right'} component="th" scope="row" style={{  fontSize: "14px", border: "2px solid #ccc" }}>
                                                                                    {Number(data.lastMonthDebt).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>
                                                            <TablePagination
                                                                component="div"
                                                                count={loanWiseDetails.length}
                                                                onChangePage={handlePageChange}
                                                                onChangeRowsPerPage={handleLimitChange}
                                                                page={page}
                                                                rowsPerPage={limit}
                                                                rowsPerPageOptions={[5, 10, 25]}
                                                            />
                                                        </Box> : null} 
                                            </CardContent>
                                            {loanWiseDetails.length > 0 ?
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <Button
                                                        color="primary"
                                                        id="btnRecord"
                                                        type="submit"
                                                        variant="contained"
                                                        style={{ marginRight: '1rem' }}
                                                        className={classes.colorRecord}
                                                        onClick={createFile}
                                                    >
                                                        EXCEL
                                                    </Button>
                                                    <div>&nbsp;</div>
                                                    <ReactToPrint
                                                        documentTitle={"Loan Wise Crop Report"}
                                                        trigger={() => <Button
                                                            color="primary"
                                                            id="btnCancel"
                                                            variant="contained"
                                                            style={{ marginRight: '1rem' }}
                                                            className={classes.colorCancel}
                                                        >
                                                            PDF
                                                        </Button>}
                                                        content={() => componentRef.current}
                                                        pageStyle={getPageMargins()}
                                                    />
                                                    <div hidden={true}>
                                                        <CreatePDF ref={componentRef} LoanInputData={loanInputData} LoanWiseDetails={loanWiseDetails}
                                                            LoanReportSearchData={selectedSearchValues} />
                                                    </div>
                                                </Box> : null}
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Page>
        </Fragment>
    )
}